<template>
     <div class="permission">
        <img src="https://st-gdx.dancf.com/assets/20191023-134045-5ddb.png?x-oss-process=image/resize,w_252/interlace,1,image/format,webp" alt="empty">
        <h4>还没登录哦</h4>
        <p>登录后即可使用上传素材、收藏模板等功能</p>
        <Button type="primary" @click="showLoginModal">立即登录</Button>
     </div>
     <LayoutFooter/>
</template>
<script lang="ts">
import { defineComponent} from 'vue'
import { MutationTypes, useStore } from '@/store'
import LayoutFooter from '../components/layout/Footer.vue'
export default defineComponent({
  components: {
    LayoutFooter
  },
  setup() {
    const store = useStore()
    const showLoginModal = () => {
      store.commit(MutationTypes.SET_LOGIN_MODAL_STATE, true)
    }
    return {
      showLoginModal
    }
  },
})
</script>

<style lang="scss" scoped>
.permission {
  height: 100%;
  min-height: 500px;
  text-align: center;
  padding-top: 100px;
  img {
    width: 168px;
    height: 168px;
  }
  h4 {
    font-weight: bold;
    font-size: 16px;
  }
  p {
    padding: 15px 0 30px 0;
  }
}
</style>
